import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import StandardTable from '@/components/table/StandardTable';
import { queryWaitMeApplys, queryAbnormalApplys } from '@/services/flow';
var columns = [{
  title: '申请流水号',
  dataIndex: 'fillId',
  align: 'center',
  width: 20
}, {
  title: '标题',
  dataIndex: 'formName',
  key: 'formName',
  width: 90
}, {
  title: '申请人',
  dataIndex: 'startUserName',
  key: 'formName',
  width: 50
}, {
  title: '类型',
  dataIndex: 'category',
  key: 'category',
  width: 30
},
// {
//   title: '流水号',
//   dataIndex: 'description',
//   scopedSlots: { customRender: 'description' }
// },
{
  title: '发起时间',
  dataIndex: 'processStartTime',
  key: 'processStartTime',
  width: 50
},
// {
//     title: '当前节点',
//     dataIndex: 'taskName',
//     key: 'taskName'
// },
{
  title: '异常原因',
  dataIndex: 'abnormalCause',
  scopedSlots: {
    customRender: 'abnormalCause'
  },
  width: 20
}, {
  title: '概述',
  dataIndex: 'summary',
  width: 20
}, {
  title: '操作',
  key: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  width: 20
}];
export default {
  name: 'QueryList',
  components: {
    StandardTable: StandardTable
  },
  data: function data() {
    return {
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      searchVal: {
        summary: '',
        fillId: '',
        formName: '',
        abnormalCause: undefined,
        startTime: '',
        endTime: ''
      },
      timeValue: [],
      expand: false,
      columns: columns,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        total: this.total,
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        onShowSizeChange: this.pageSizeChange,
        onChange: this.pageChange
      },
      form: {
        // formName: this.searchVal.formName,
        // abnormalCause: this.searchVal.abnormalCause,
        // startTime: this.searchVal.startTime,
        // endTime: this.searchVal.endTime,
        pageSize: 10,
        currentNo: 1
      },
      abnormalCause: [{
        itemValue: '1',
        itemKey: '节点无人审核'
      }, {
        itemValue: '2',
        itemKey: '超时'
      }]
    };
  },
  methods: {
    loadData: function loadData() {
      this.onClickSearchTableList();
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    queryTableList: function queryTableList() {
      this.form.currentNo = 1;
      this.pagination.current = 1;
      this.onClickSearchTableList();
      sessionStorage.removeItem('Pagination_abnormalProcess');
    },
    onClickSearchTableList: function onClickSearchTableList() {
      var _this = this;
      this.loading = true;
      queryAbnormalApplys({
        summary: this.searchVal.summary,
        fillId: this.searchVal.fillId,
        formName: this.searchVal.formName,
        abnormalCause: this.searchVal.abnormalCause,
        startTime: this.searchVal.startTime,
        endTime: this.searchVal.endTime,
        pageSize: this.form.pageSize,
        currentNo: this.form.currentNo
      }).then(function (res) {
        var data = res.data.data;
        _this.dataSource = data && Object.prototype.hasOwnProperty.call(data, 'rows') ? data.rows : [];
        _this.total = data && Object.prototype.hasOwnProperty.call(data, 'total') ? data.total : 0;
        _this.pagination.total = _this.total;
      }).finally(function () {
        _this.loading = false;
      });
    },
    pageSizeChange: function pageSizeChange(val, pageNum) {
      this.loading = true;
      this.pagination.pageSize = pageNum;
      this.pagination.current = 1;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      this.onClickSearchTableList(); //获取列表数据
    },
    pageChange: function pageChange(page, val) {
      this.loading = true;
      this.pagination.current = page;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      this.onClickSearchTableList(); //获取列表数据
      sessionStorage.setItem('Pagination_abnormalProcess', JSON.stringify(this.pagination));
    },
    onViewAfterMeApply: function onViewAfterMeApply(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: record.processInstanceId
        }
      });
    },
    timeChange: function timeChange(date, dateString) {
      if (date, dateString) {
        this.timeValue = date;
        this.searchVal.startTime = dateString[0];
        this.searchVal.endTime = dateString[1];
      }
    },
    resetSearchVal: function resetSearchVal() {
      this.timeValue = [];
      this.searchVal = {
        summary: '',
        fillId: '',
        formName: '',
        abnormalCause: undefined,
        startTime: '',
        endTime: ''
      };
      this.loadData();
    }
  },
  mounted: function mounted() {
    var savedPagination = sessionStorage.getItem('Pagination_abnormalProcess');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.loadData();
  }
};